<template>
  <div class="tab-bar-placeholder">
    <div class="tab-bar-fixed" style="z-index: 20">
      <div class="tab-bar-wrapper" >
        <template v-for="(item, index) in config">
          <div class="tab-bar-item" :class="{active: index === value}" :key="index" @click="onClick(index)">
            <div class="tab-bar-item-icon">
              <img :src="index !== value ? item.iconPath : item.selectedIconPath" alt="">
            </div>
            <div class="tab-bar-item-text">
              {{item.text}}
            </div>
          </div>
        </template>
        <number-keyboard safe-area-inset-bottom />
      </div>
    </div>
  </div>
</template>
<script>

import {NumberKeyboard} from 'vant'
export default {
  name: 'tabBar',
  components: {
    NumberKeyboard
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    config: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClick(index) {
      if(this.value !== index)  {
        this.$emit('input', index)
        this.$emit('change', index, this.config[index])
      }
    }
  }
}

</script>

<style scoped lang="scss">
.tab-bar-placeholder {
  height: 66px;
}
.tab-bar-wrapper {
  position: relative;
  text-align: center;
  box-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.25);
  background-color: #fff;
}
.tab-bar-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.tab-bar-item {
  padding: 13px 0;
  cursor: pointer;
  display: inline-block;
  width: 33.333333%
}
.tab-bar-item-icon {
  font-size: 0;
  img {
    width: 24px;
    height: 24px;
  }
}
.tab-bar-item-text {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  color: rgba(18, 18, 18, 1);
  text-align: center;
  vertical-align: top;
}
.tab-bar-item.active {
  .tab-bar-item-text {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
    color: rgba(79, 82, 255, 1);
    text-align: center;
    vertical-align: top;
  }
}
</style>